function dateToMonthYear(date) {
  if (date == null) {
    return null;
  }

  if (!Object.prototype.toString.call(date) === "[object Date]") {
    return null;
  }

  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  let monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

  let month = date.getMonth();
  let year = date.getFullYear();

  return `${monthNames[month]} ${year}`;
}

function dateStringToFormat(dateString) {
  const dt = new Date(dateString);
  if (dt == null) {
    return "";
  }

  // not designed to handle dates way in the past. Simple short circuit for values coming back as 0's
  if (dt.getFullYear() < 100) {
    return "";
  }
  return dt.toLocaleDateString("en-us");
}

export { dateToMonthYear, dateStringToFormat }